import React from 'react';
import { motion } from 'framer-motion';
const destinations = [{
  id: 'paris',
  name: 'Paris',
  image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=800&q=80',
  span: 'col-span-1 md:col-span-2 row-span-2',
  height: 'h-64 md:h-[544px]'
}, {
  id: 'santorini',
  name: 'Santorini',
  image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?auto=format&fit=crop&w=800&q=80',
  span: 'col-span-1 md:col-span-1 row-span-1',
  height: 'h-64 md:h-64'
}, {
  id: 'dubai',
  name: 'Dubai',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=800&q=80',
  span: 'col-span-1 md:col-span-1 row-span-1',
  height: 'h-64 md:h-64'
}, {
  id: 'bali',
  name: 'Bali',
  image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=800&q=80',
  span: 'col-span-1 md:col-span-1 row-span-1',
  height: 'h-64 md:h-64'
}, {
  id: 'london',
  name: 'London',
  image: 'https://images.unsplash.com/photo-1486299267070-83823f5448dd?auto=format&fit=crop&w=800&q=80',
  span: 'col-span-1 md:col-span-1 row-span-1',
  height: 'h-64 md:h-64'
}];
export function FeaturedDestinations() {
  return <section id="destinations" className="py-20 bg-luxury-cream" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12" data-id="element-41">
          <div data-id="element-42">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-4xl md:text-5xl font-italiana text-luxury-slate mb-4" data-id="element-43">
              Popular Destinations
            </motion.h2>
            <motion.div initial={{
            opacity: 0,
            width: 0
          }} whileInView={{
            opacity: 1,
            width: '60px'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="h-1 bg-luxury-blue rounded-full" data-id="element-44" />
          </div>
          <motion.button initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="mt-6 md:mt-0 text-luxury-blue font-medium hover:text-blue-700 transition-colors flex items-center" data-id="element-45">
            Explore all destinations <span className="ml-2" data-id="element-46">→</span>
          </motion.button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6" data-id="element-47">
          {destinations.map((dest, index) => <motion.div key={dest.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`group relative rounded-xl overflow-hidden cursor-pointer shadow-sm hover:shadow-float transition-all duration-300 ${dest.span} ${dest.height}`} data-id="element-48">
              <img src={dest.image} alt={dest.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-49" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-50" />

              <div className="absolute bottom-0 left-0 p-6" data-id="element-51">
                <h3 className="text-2xl md:text-3xl font-italiana text-white drop-shadow-md" data-id="element-52">
                  {dest.name}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}